/**
 * 视频关键点 组件
 */
import React, { useEffect, useState } from 'react';
import { InputNumber } from 'tdesign-react';

interface IKeyPointsProps {
  value?: string;
  onChange?: (key: any) => void;
  children?: any;
  valueType?: 's' | 'ms';
  retType?: 'string' | 'number';
}

const styleInput = {
  marginBottom: '5px',
  marginRight: '5px',
};

const KeyPointComponent: React.FC<IKeyPointsProps> = (props) => {
  const { valueType = 'ms', retType = 'string' } = props;
  const [compValue, setCompValue] = useState<any>([0, 0, 0, 0]);

  useEffect(() => {
    if (typeof props.value === 'undefined') {
      setCompValue([0, 0, 0, 0]);
      return;
    }
    asyncTime(+props.value);
  }, [props.value]);

  const asyncTime = (enterTime: number) => {
    const timer = valueType === 's' ? enterTime * 1000 : enterTime;
    const hour = Math.floor(timer / 3600 / 1000);
    const min = Math.floor(timer / 1000 / 60) % 60;
    const sec = Math.floor(timer / 1000) % 60;
    const msec = timer % 1000;

    setCompValue([hour, min, sec, msec]);
  };

  const updateTimer = (val = 0, pos: number) => {
    const tmpValue = compValue.length === 0 ? [0, 0, 0, 0] : [...compValue];
    tmpValue[pos] = val;
    let timer = +tmpValue[3] + +tmpValue[2] * 1000 + +tmpValue[1] * 60000 + +tmpValue[0] * 3600000;

    if (valueType === 's') {
      timer = timer / 1000;
    }

    setCompValue([...tmpValue]);
    props.onChange?.(retType === 'string' ? `${timer}` : timer);
  };

  return (
    <div>
      <InputNumber
        style={styleInput}
        suffix="时"
        theme="normal"
        min={0}
        value={compValue[0]}
        onChange={(e) => {
          updateTimer(e as number, 0);
        }}
        autoWidth
      />
      <InputNumber
        style={styleInput}
        suffix="分"
        theme="normal"
        min={0}
        max={59}
        value={compValue[1]}
        onChange={(e) => {
          updateTimer(e as number, 1);
        }}
        autoWidth
      />
      <InputNumber
        style={styleInput}
        suffix="秒"
        theme="normal"
        min={0}
        max={59}
        value={compValue[2]}
        onChange={(e) => {
          updateTimer(e as number, 2);
        }}
        autoWidth
      />
      {valueType === 'ms' ? (
        <InputNumber
          style={styleInput}
          suffix="毫秒"
          theme="normal"
          min={0}
          max={999}
          value={compValue[3]}
          onChange={(e) => {
            updateTimer(e as number, 3);
          }}
          autoWidth
        />
      ) : null}
    </div>
  );
};

export default KeyPointComponent;
